import React, { useEffect, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import Typography from "@mui/material/Typography";
import TabOutlet from "app/components/TabOutlet";
import { NotFoundView } from "../../../../views";
import { actions as OwnerActions, selectors } from "../../Ducks/Owner.duck";
import { selectors as appSelectors } from "../../../App/Ducks/App.duck";
const OwnerSettingsPage = () => {
  const dispatch = useDispatch();
  const tabData = useMemo(() => {
    return [
      {
        path: "employee-types",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employees" })
      },
      {
        path: "employers",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers" }),
        disabled: true
      },
      {
        path: "users",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "users" }),
        disabled: true
      },
      {
        path: "credentials-requests",
        label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credentialRequests" }),
        disabled: true
      }
    ];
  }, []);
  const title = useMemo(() => {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "menu.settings" })));
  }, []);
  const breadcrumb = useMemo(() => {
    return {
      title,
      data: {
        otherElements: "",
        hideTrail: true
      }
    };
  }, [title]);
  const ownerId = useSelector((state) => appSelectors.selectOwnerId(state.AppReducer));
  const { item: owner, loaded, loading } = useSelector((state) => selectors.selectOwner(state.OwnerReducer));
  useEffect(() => {
    if (!owner || owner.ownerId !== ownerId) {
      dispatch(OwnerActions.owner.requestData({ ownerId }));
    }
  }, [owner, dispatch, ownerId]);
  const exists = loading || loaded && !!owner;
  return exists ? /* @__PURE__ */ React.createElement(TabOutlet, { tabs: tabData, breadcrumb }) : /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { element: /* @__PURE__ */ React.createElement(NotFoundView, null), path: "*" }));
};
export default OwnerSettingsPage;
